import type { TFunction } from "i18next";
import type { components } from "@/api/types";

type AutoSummary = components["schemas"]["AutoSummary"];

/** Carrier shape: full ApprovalRecord, PendingSummaryItem and any other
 * payload that exposes `auto_summary` are all valid inputs. */
interface HasAutoSummary {
  auto_summary: AutoSummary;
}

/**
 * Render the human-readable approval card title from `auto_summary.kind` +
 * params. Backend guarantees `auto_summary` is populated for every record;
 * if i18n key is missing, i18next surfaces the raw key — this is the
 * intended visible-error fallback (no silent drop to `kind`).
 */
export function formatAutoSummary(record: HasAutoSummary, t: TFunction): string {
  const { kind, params } = record.auto_summary;
  const merged: Record<string, unknown> = { ...(params ?? {}) };
  // i18next plural picks variant from `count`. task_move uses delta_days
  // (signed) — pass it as count so ru gets день/дня/дней correctly.
  if (kind === "task_move" && typeof merged.delta_days === "number") {
    merged.count = merged.delta_days as number;
  }
  return t(`approvals.autoSummary.${kind}`, merged);
}
